import { createActions, createReducer } from 'reduxsauce'

import ConsultaConvenioParceriaConcedidoService from '../../servicos/ConsultaConvenioParceriaConcedidoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaConsultaConvenioParceriaConcedidoInicio: [],
    buscaConsultaConvenioParceriaConcedidoSucesso: ['consultaConvenioParceriaConcedido'],
    buscaConsultaConvenioParceriaConcedidoErro: ['erro'],
    setSelecionadoConsultaConvenioParceriaConcedidoSucesso: ['selecionado'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
    selecionado: null,
    dataSincronizacaoDados: null,
}

// Ação para busca completa
Creators.buscaConsultaConvenioParceriaConcedido = filtro => {
    return dispatch => {
        dispatch(Creators.buscaConsultaConvenioParceriaConcedidoInicio())
        let serv = new ConsultaConvenioParceriaConcedidoService()
        return serv
            .consultar(filtro)
            .then(response => dispatch(Creators.buscaConsultaConvenioParceriaConcedidoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaConsultaConvenioParceriaConcedidoErro(error)))
    }
}

const buscaConsultaConvenioParceriaConcedidoInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaConsultaConvenioParceriaConcedidoErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaConsultaConvenioParceriaConcedidoSucesso = (state = INITIAL_STATE, action) => {
    return {
        ...state,
        lista: action.consultaConvenioParceriaConcedido.resultado,
        dataSincronizacaoDados: action.consultaConvenioParceriaConcedido.dataSincronizacaoDados,
        carregando: false,
    }
}

const setSelecionadoConsultaConvenioParceriaConcedidoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, selecionado: action.selecionado, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_CONSULTA_CONVENIO_PARCERIA_CONCEDIDO_INICIO]: buscaConsultaConvenioParceriaConcedidoInicio,
    [Types.BUSCA_CONSULTA_CONVENIO_PARCERIA_CONCEDIDO_ERRO]: buscaConsultaConvenioParceriaConcedidoErro,
    [Types.BUSCA_CONSULTA_CONVENIO_PARCERIA_CONCEDIDO_SUCESSO]: buscaConsultaConvenioParceriaConcedidoSucesso,
    [Types.SET_SELECIONADO_CONSULTA_CONVENIO_PARCERIA_CONCEDIDO_SUCESSO]: setSelecionadoConsultaConvenioParceriaConcedidoSucesso,
})
